import {firebase} from "../firebase";
import {auth} from "./firebase";
import remergeCondition from "./conditions";
import store from "../store";
import {fetchOrganizationsAsyncActions} from "../store/organizations/actions";
import cfApi from "../api/cfApi";

// TODO move this into store
const userProfile = {
    currentUser: firebase.auth.currentUser,
    idToken: ''
};

firebase.auth.onAuthStateChanged(authUser => {
    if (!remergeCondition(authUser)) {
        return
    }
    let currentUser = auth.currentUser;
    if (currentUser != null) {
        currentUser.getIdToken().then(function (result) {
            userProfile.currentUser = currentUser;
            userProfile.idToken = result;

            cfApi.interceptors.request.use((config) => {
                config.headers.common['Authorization'] = 'Bearer ' + userProfile.idToken;
                return config
            }, function (error) {
                // Do something with request error
                return Promise.reject(error)
            });

            store.dispatch(fetchOrganizationsAsyncActions.request({}))
        }).catch(function (error) {
            console.log(error);
        })
    }
});

export default userProfile;